module.exports = __webpack_public_path__ + "img/delete-account.b73a7fb2.svg";